module.exports = __webpack_public_path__ + "img/Nekologic.971b4acb.png";